import { DateTime } from "luxon";

// Días (ISO yyyy-mm-dd, en la zona del venue) que cubre un evento.
//
// Un evento que termina exactamente a medianoche NO ocupa el día siguiente —
// misma regla que utils/ocupacion.js; sin ella cada bloqueo se derrama un día
// y el calendario del año se ve mucho más lleno de lo que está.
//
// Vive aparte porque lo comparten la vista de mes con carriles y la del año.
export function diasDeEvento(ev, zone) {
  const ini = DateTime.fromJSDate(ev.start, { zone });
  if (!ini.isValid) return [];
  let fin = ev.end ? DateTime.fromJSDate(ev.end, { zone }) : ini;
  if (!fin.isValid || fin <= ini) fin = ini;
  if (fin.hour === 0 && fin.minute === 0 && fin > ini) fin = fin.minus({ days: 1 });
  const dias = [];
  let cur = ini.startOf("day");
  const ultimo = fin.startOf("day");
  // Cota dura: un rango absurdo por datos malos no debe colgar el render.
  for (let i = 0; i <= 366 && cur <= ultimo; i++) {
    dias.push(cur.toISODate());
    cur = cur.plus({ days: 1 });
  }
  return dias;
}
